import BoxLoader from "../../general/boxLoader";
import EmptyBox from "../../general/emptyBox";
import React from "react";
import VisitCardsBoxItem from "./visitCardsBox_Item";

type VisitCardsBoxProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
}

const VisitsCardsBox = ({
  dataList,
  dataListTitles,
  isRequesting
}: VisitCardsBoxProps) => {
  const _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
    return <VisitCardsBoxItem item={item} dataListTitles={dataListTitles} key={i}/>
  })
  return (
    <div>
      {isRequesting ? <BoxLoader/> : _dataList ? _dataList : <EmptyBox content={''} className={''} children={''}/>}
    </div>
  )
}

export default VisitsCardsBox;